<template>
    <div class="corporatecommunity">
<!--        <spinner class="pink" v-model="toggleSpinner" v-if="toggleSpinner" size="lg" fixed text="refreshing event"></spinner>-->
        <div class="container">
            <div class="row">
                <div class="col-md-2">
                    <div class="smallimgholder">
                       <br />
                        <button v-if="siblingCorps && user.isSuperUser"  v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn formButton btn-block smallimgholder" type="button"  @click="openSwitchModal()"><i class="fa fa-exchange" aria-hidden="true"></i> {{getParentCorporation.name}}
                        </button>
                        <img :src="smallImage" alt="CORP IMAGE" :title="user.corporation.name"/><div class="hidemobile"><br /> <b> {{user.corporation.pageWelcomeMessage}}</b>
                        <div :class="{ hidden: isHidden() }">
                        <br /><br />
                        <img src="../assets/toneApp.png" alt="APP QR CODE" text="APP QR Code"/><br /> {{user.corporation.pageWelcomeMessage}}Scan the QR code to download our app and enjoy Tone on the go!
                        <br />
<!--                        <a style="cursor: pointer" v-bind:style="{ color: getCorpHeadingColor}" v-if="user && (user.corporation && user.corporation.pageAdmin)" @click="$router.push('/corporation/manage-page')"><h4>Manage Custom Features</h4></a><br />-->
                        </div>
                    </div>
                    </div>

                </div>
                <div class="col-md-10 margin-bottom-40">
                        <div class="tabs">
                            <ul>
                                <!-- li>{{selectedTab}}{{getCorpPlaylists.playlistCategory}}</li -->
                                <li v-bind:style="[selectedTab === 'community' ? {'borderBottom': '1px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '1px solid #333 !important'}]" v-if="user.corporation.showSpotlightSection || user.corporation.showPinnedMessages" @click="switchTab('community')" :class="{ current: selectedTab === 'community' }" class="community"><a v-bind:style="[selectedTab === 'community' ? {'color': getCorpHeadingColor} : {'color': '#333'}]" href="javascript:">Community</a></li>
                                <li v-bind:style="[selectedTab === 'events' ? {'borderBottom': '1px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '1px solid #333 !important'}]" @click="switchTab('events')" :class="{ current: selectedTab === 'events' }" class="events"><a v-bind:style="[selectedTab === 'events' ? {'color': getCorpHeadingColor} : {'color': '#333'}]" href="javascript:"><span class="hidemobile">Coaching</span> Events</a></li>
                                <li v-bind:style="[selectedTab === 'videos' ? {'borderBottom': '1px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '1px solid #333 !important'}]" v-if= "getCorpPrivateVideos" @click="switchTab('videos')" :class="{ current: selectedTab === 'videos' }" class="events"><a v-bind:style="[selectedTab === 'videos' ? {'color': getCorpHeadingColor} : {'color': '#333'}]" href="javascript:"> Videos</a></li>
                                <li v-bind:style="[selectedTab === 'playlists' ? {'borderBottom': '1px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '1px solid #333 !important'}]" v-if="getCorpPlaylists && user.corporation.corporationId !== 200" @click="switchTab('playlists')" :class="{ current: selectedTab === 'playlists' }" class="playlists"><a v-bind:style="[selectedTab === 'playlists' ? {'color': getCorpHeadingColor} : {'color': '#333'}]" href="javascript:">Playlists</a></li>
                                <li v-bind:style="[selectedTab === 'playlists' ? {'borderBottom': '1px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '1px solid #333 !important'}]" v-if="getCorpPlaylists && user.corporation.corporationId === 200" @click="switchTab('manplaylists')" :class="{ current: selectedTab === 'playlists' }" class="playlists"><a v-bind:style="[selectedTab === 'manplaylists' ? {'color': getCorpHeadingColor} : {'color': '#333'}]" href="javascript:">Manager Playlists</a></li>
                                <li v-bind:style="[selectedTab === 'playlists' ? {'borderBottom': '1px solid ' + getCorpHeaderColor + ' !important'} : {'borderBottom': '1px solid #333 !important'}]" v-if="getCorpPlaylists && user.corporation.corporationId === 200" @click="switchTab('dirplaylists')" :class="{ current: selectedTab === 'playlists' }" class="playlists"><a v-bind:style="[selectedTab === 'dirplaylists' ? {'color': getCorpHeadingColor} : {'color': '#333'}]" href="javascript:">Director Playlists</a></li>
                            </ul>
                        </div>
                        <div v-if="selectedTab === 'community'" class="tabContent" id="tabs-1" :class="{ current: tabs.community }">
                            <div class="row video-row introparacard" v-if="user.corporation.showSpotlightSection">
                                <div class="clearfix"></div>
                                    <div class="col-sm-3" v-if="user.corporation.spotlightPic">
                                        <img :src="user.corporation.spotlightPic" alt="SPOTLIGHT IMAGE" title="In Spotlight" />
                                    </div>
                                <br>
                                    <div class="col-sm-9">
                                        <p v-if="user.corporation.spotlightPara1" v-html="user.corporation.spotlightPara1"></p>
                                        <p v-if="user.corporation.spotlightPara2" v-html="user.corporation.spotlightPara2"></p>
                                        <p v-if="user.corporation.spotlightPara3" v-html="user.corporation.spotlightPara3"></p>
                                    </div>
                                    <div class="clearfix"></div>
                                <div class="col-sm-12">
                                    <blockquote v-if="user.corporation.spotlightQuote">"{{user.corporation.spotlightQuote}}"</blockquote>
                                    <div class="clearfix"></div>
                                    <hr class="redhr" v-bind:style="{ 'border-color': this.getCorpHeaderColor + ' !important'}"/>
                                </div>

                            </div>
                            <div class="pinnedmsgs" v-if="getCorporationPinnedMsgs && (user.corporation.showPinnedMessages || user.corporation.showPinnedMessages === 1)">
                                <h3 v-if="user.corporation.pinnedMessageHeading" v-bind:style="{ color: getCorpHeadingColor + ' !important'}">{{user.corporation.pinnedMessageHeading}}&nbsp;<i class="fa fa-map-pin "></i></h3>
                                <div class="clearfix"></div>
                                <div class="borderedbox" v-for="msg in getCorporationPinnedMsgs">
                                    <h4>{{msg.msgSenderName}} <small>{{msg.msgSentDateFmt}}</small></h4>
                                    <p v-html="msg.corpAdminMessage"></p>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <div v-if="selectedTab === 'events'" class="tabContent" id="tabs-2" :class="{ current: tabs.events }">
                            <div class="row video-row" v-if="getCorpMainEvent">
                                <h3 v-if="getCorpMainEvent.isPrivate === 1"><b>Join {{user.corporation.name}} and TONE Networks for this EXCLUSIVE coaching event on {{getDateReference(getCorpMainEvent.start_date, 'str')}}</b></h3>
                                <h3 v-if="getCorpMainEvent.isPrivate !== 1"><b>Join our monthly livestream events for interactive coaching that is designed for your personal and professional needs. Get your questions ready!</b></h3>
                                <div class="col-md-12 pinkbordercomp"  v-if="getCorpMainEvent && getCorpMainEvent.type !== '3' && showJoin(getCorpMainEvent.eventId)" >
                                    <rulescomp v-if="getCorpMainEvent" :data="getCorpMainEvent" v-bind:style="{border: '1px solid ' + getCorpHeaderColor}">Loading event rules</rulescomp>
                                </div>
                                <div class="clearfix" style="height:30px"></div>
                                <div class="col-sm-6 imgresponsive"><img :src="getCorpMainEvent.img_url" alt="CORP MAIN EVENT BANENR" :title="getCorpMainEvent.title"></div>
                                <div class="col-sm-6 text-left large-text">
                                    <h3 v-bind:style="{ color: getCorpHeadingColor + ' !important'}">{{getCorpMainEvent.title}}</h3>
                                    <p>{{getCorpMainEvent.longDescription}}</p>
                                    <br>
                                    <br><br>
                                    <p>{{getDateReference(getCorpMainEvent.start_date, 'str')}}</p>
                                    <br>
                                    <div v-on:click="calendarLogging($event, getCorpMainEvent.title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(getCorpMainEvent.eventId)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                        Add to Calendar
                                        <span class="start">{{getCorpMainEvent.start_date}}</span>
                                        <span class="end">{{getCorpMainEvent.end_date}}</span>
                                        <span class="timezone">America/New_York</span>
                                        <span class="title">{{getCorpMainEvent.title}}</span>
                                        <span class="description">{{getCorpMainEvent.longDescription}}</span>
                                        <span class="location">
                                            <span v-if="getCorpMainEvent.isPrivate === 1">
                                                <span v-if="getCorpMainEvent.type === '1'">{{privateEventURL}}</span>
                                                <span v-if="getCorpMainEvent.type === '2'">{{privateEventURL}}</span>
                                                <span v-if="getCorpMainEvent.type === '3'">{{user.corporation.name}}'s Self-Hosted Event</span>
                                            </span>
                                            <!-- span v-else>
                                                <span v-if="getCorpMainEvent.type === '1'">{{eventURL}}/event/{{getCorpMainEvent.eventId}}</span>
                                                <span v-if="getCorpMainEvent.type === '2'">{{eventURL}}/event/{{getCorpMainEvent.eventId}}</span>
                                                <span v-if="getCorpMainEvent.type === '3'">{{user.corporation.name}}'s Self-Hosted Event</span>
                                            </span -->
                                            <span v-else>
                                                <span v-if="getCorpMainEvent.type === '1'">{{buildEventLink (getCorpMainEvent.eventId) }}</span>
                                                <span v-if="getCorpMainEvent.type === '2'">{{buildEventLink (getCorpMainEvent.eventId) }}</span>
                                                <span v-if="getCorpMainEvent.type === '3'">{{user.corporation.name}}'s Self-Hosted Event</span>
                                            </span>
                                        </span>
                                    </div>
                                    <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(getCorpMainEvent)" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                                        <i class="fa fa-share-square-o"></i> Share
                                    </button>
                                </div>
                                <div class="clearfix"></div>
                                <div class="col-md-12 pinkbordercomp" v-if="getCorpMainEvent && getCorpMainEvent.type !== '3' && !showJoin(getCorpMainEvent.eventId)" >
                                    <rulescomp v-if="getCorpMainEvent" :data="getCorpMainEvent" v-bind:style="{border: '1px solid ' + getCorpHeaderColor}">Loading event rules</rulescomp>
                                </div>
                            </div>

                            <div class="row" v-if="getCorpPrivateEvents && getCorpPrivateEvents.length >= 2">
                                <h3>
                                    <b>
                                        <h3 v-if="user.corporation.privateEventHeading" v-bind:style="{ color: getCorpHeadingColor + ' !important'}"><b>{{user.corporation.privateEventHeading}}</b></h3>
                                    </b>
                                </h3>
                                <div class="col-sm-6 imgresponsive large-text text-left">
                                    <div class="clearfix" style="height:30px"></div>
                                    <img :src="getCorpPrivateEvents[0].img_url" alt="PRIVATE EVENT BANNER" :title="getCorpPrivateEvents[0].title">
                                    <div class="clearfix"></div>
                                    <h3  v-bind:style="{ color: getCorpHeadingColor + ' !important'}">{{getCorpPrivateEvents[0].title}}</h3>
                                    <p>{{getCorpPrivateEvents[0].longDescription}}</p>
                                    <br><br>
                                    <p>{{getDateReference(getCorpPrivateEvents[0].start_date, 'str')}}</p>
                                    <br>
                                    <div v-on:click="calendarLogging($event, getCorpPrivateEvents[0].title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(getCorpPrivateEvents[0].eventId)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                        Add to Calendar
                                        <span class="start">{{getCorpPrivateEvents[0].start_date}}</span>
                                        <span class="end">{{getCorpPrivateEvents[0].end_date}}</span>
                                        <span class="timezone">America/New_York</span>
                                        <span class="title">{{getCorpPrivateEvents[0].title}}</span>
                                        <span class="description">{{getCorpPrivateEvents[0].longDescription}}</span>
                                        <!--<span class="location"><span v-if="getCorpPrivateEvents[0].type === '1'">{{eventURL}}/event/{{getCorpPrivateEvents[0].eventId}}</span><span v-else>{{eventURL}}/event/{{getCorpPrivateEvents[0].eventId}}</span></span>-->
                                        <span class="location">
                                            <span v-if="getCorpPrivateEvents[0].type === '1'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[0].type === '2'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[0].type === '3'">{{user.corporation.name}}'s Self-Hosted Event</span>
                                        </span>
                                    </div>
                                    <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(getCorpPrivateEvents[0])" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                                        <i class="fa fa-share-square-o"></i> Share
                                    </button>
<!--                                    <button v-if="user && user.corporation && (user.isSuperUser || user.corporation.pageAdmin)" @click="openCorporateImageShareModal(getCorpMainEvent)" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">-->
<!--                                        <i class="fa fa-share-square-o"></i> Share-->
<!--                                    </button>-->
                                </div>
                                <div class="col-sm-6 imgresponsive large-text text-left">
                                    <div class="clearfix" style="height:30px"></div>
                                    <img :src="getCorpPrivateEvents[1].img_url" alt="PRIVATE EVENT BANNER" :title="getCorpPrivateEvents[1].title">
                                    <div class="clearfix"></div>
                                    <h3 v-bind:style="{ color: getCorpHeadingColor + ' !important'}">{{getCorpPrivateEvents[1].title}}</h3>
                                    <p>{{getCorpPrivateEvents[1].longDescription}}</p>
                                    <br><br>
                                    <p>{{getDateReference(getCorpPrivateEvents[1].start_date, 'str')}}</p>
                                    <br>
                                    <div v-on:click="calendarLogging($event, getCorpPrivateEvents[1].title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(getCorpPrivateEvents[1].eventId)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                        Add to Calendar
                                        <span class="start">{{getCorpPrivateEvents[1].start_date}}</span>
                                        <span class="end">{{getCorpPrivateEvents[1].end_date}}</span>
                                        <span class="timezone">America/New_York</span>
                                        <span class="title">{{getCorpPrivateEvents[1].title}}</span>
                                        <span class="description">{{getCorpPrivateEvents[1].longDescription}}</span>
                                        <!--<span class="location"><span v-if="getCorpPrivateEvents[1].type === '1'">{{eventURL}}/event/{{getCorpPrivateEvents[1].eventId}}</span><span v-else>{{eventURL}}/event/{{getCorpPrivateEvents[1].eventId}}</span></span>-->
                                        <span class="location">
                                            <span v-if="getCorpPrivateEvents[1].type === '1'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[1].type === '2'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[1].type === '3'">{{user.corporation.name}}'s Self-Hosted Event</span>
                                        </span>
                                    </div>
                                    <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(getCorpPrivateEvents[1])" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                                        <i class="fa fa-share-square-o"></i> Share
                                    </button>

<!--                                    <button v-if="user && user.corporation" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">-->
<!--                                        <i class="fa fa-share-square-o"></i> Share-->
<!--                                    </button>-->
                                </div>
                            </div>
                            <div class="row" v-if="getCorpPrivateEvents && getCorpPrivateEvents.length === 1">
                                <h3>
                                    <b>
                                        <h3 v-if="user.corporation.privateEventHeading"><b>{{user.corporation.privateEventHeading}}</b></h3>
                                    </b>
                                </h3>
                                <div class="col-sm-6 m-auto imgresponsive large-text text-left">
                                    <div class="clearfix" style="height:30px"></div>
                                    <img :src="getCorpPrivateEvents[0].img_url" alt="PRIVATE EVENT BANNER" :title="getCorpPrivateEvents[0].title">
                                    <div class="clearfix"></div>
                                    <h3 v-bind:style="{ color: getCorpHeadingColor + ' !important'}">{{getCorpPrivateEvents[0].title}}</h3>
                                    <p>{{getCorpPrivateEvents[0].longDescription}}</p>
                                    <br><br>
                                    <p>{{getDateReference(getCorpPrivateEvents[0].start_date, 'str')}}</p>
                                    <br>
                                    <div v-on:click="calendarLogging($event, getCorpPrivateEvents[0].title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(getCorpPrivateEvents[0].eventId)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                        Add to Calendar
                                        <span class="start">{{getCorpPrivateEvents[0].start_date}}</span>
                                        <span class="end">{{getCorpPrivateEvents[0].end_date}}</span>
                                        <span class="timezone">America/New_York</span>
                                        <span class="title">{{getCorpPrivateEvents[0].title}}</span>
                                        <span class="description">{{getCorpPrivateEvents[0].longDescription}}</span>
                                        <span class="location">
                                            <span v-if="getCorpPrivateEvents[0].type === '1'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[0].type === '2'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[0].type === '3'">{{user.corporation.name}}'s Self-Hosted Event</span>
                                        </span>
                                    </div>
                                    <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(getCorpPrivateEvents[0])" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                                        <i class="fa fa-share-square-o"></i> Share
                                    </button>
<!--                                    <button v-if="user && user.corporation" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">-->
<!--                                        <i class="fa fa-share-square-o"></i> Share-->
<!--                                    </button>-->
                                </div>
                            </div>
                            <div class="clearfix" style="height: 50px;border-bottom: 3px solid #cbcbcb;margin-bottom: 30px;"></div>
                            <div class="sliderEventBox" v-if="getCorpPublicEvents">
                                <h2 v-if="user.corporation.toneEventHeading" >{{user.corporation.toneEventHeading}}</h2>
                                <VueSlickCarousel v-bind="carouselSettings" v-if="getCorpPublicEvents">
                                    <div class="col-sm-4" v-for="ev in getCorpPublicEvents">
                                        <h2 class="carosalh2" v-bind:style="{ color: getCorpHeadingColor + ' !important'}"><span v-if="ev.type === '1'"> TONE Live
</span><span v-else>{{ev.title}} </span></h2>
                                        <img v-bind:src="ev.img_url" class="sliderimage" alt="PUBLIC EVENT BANNER" :title="ev.title" />
                                        <!--<img v-bind:src="getExpertInfo(ev.expertId, 'img')" />-->
                                        <h2 ><a :href="'/event/' + ev.eventId" target="new" v-bind:style="{ color: getCorpHeadingColor + ' !important'}">{{getDateReference(ev.start_date, 'live')}} with {{replaceLastExpert(ev.csvExpertsNames, ',', ' & ' )}}</a></h2>
                                        <p>
                                            {{ev.longDescription}}
                                        </p>
                                        <h5 >LIVE {{getDateReference(ev.start_date, 'live2')}}</h5>
                                        <!--time left in event {{timeLeftInEvent(ev.start_date)}}-->
                                        <!--<button class="button" type="button" v-if="isUserEntrolled(ev.eventId) && isEventToday(ev.start_date, ev.end_date, ev.eventSwitchTime, getEventSwitchTime) === false"><i class="fa 2x fa-check" aria-hidden="true"></i>&nbsp;Reserved&nbsp;</button>-->
                                        <div v-on:click="calendarLogging($event, ev.title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(ev.eventId)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">
                                            Add to Calendar
                                            <span class="start">{{ev.start_date}}</span>
                                            <span class="end">{{ev.end_date}}</span>
                                            <span class="timezone">ev/New_York</span>
                                            <span class="title">{{ev.title}}</span>
                                            <span class="description">{{ev.longDescription}}</span>
                                            <!-- span class="location">{{eventURL}}/event/{{ev.eventId}}</span -->
                                            <span class="location">{{buildEventLink (ev.eventId)}}</span>
                                        </div>
                                        <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(ev)" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">
                                            <i class="fa fa-share-square-o"></i> Share
                                        </button>
                                        <!--<button  class="button" type="button" v-if="showJoin(ev.eventId)" @click="joinEvent(ev)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>-->
                                        <!--<button v-if="!isUserEntrolled(ev.eventId) && isEventToday(ev.start_date, ev.end_date) === false" @click="enrollUser(ev)" class="button">Reserve your spot</button>-->
                                    </div>
                                </VueSlickCarousel>
<!--                                <div class="slider responsive-slick-slider">-->
<!--                                    <div class="col-sm-4" v-for="ev in getCorpPublicEvents">-->
<!--                                        <h2 class="carosalh2" v-bind:style="{ color: getCorpHeadingColor + ' !important'}"><span v-if="ev.type === '1'"> TONE Live-->
<!--</span><span v-else> TONE Talk</span></h2>-->
<!--                                        <img v-bind:src="ev.img_url" class="sliderimage" alt="PUBLIC EVENT BANNER" :title="ev.title" />-->
<!--                                        &lt;!&ndash;<img v-bind:src="getExpertInfo(ev.expertId, 'img')" />&ndash;&gt;-->
<!--                                        <h2 ><a :href="'/event/' + ev.eventId" target="new" v-bind:style="{ color: getCorpHeadingColor + ' !important'}">{{getDateReference(ev.start_date, 'live')}}:  {{getExpertInfo(ev.expertId, 'name')}}</a></h2>-->
<!--                                        <p>-->
<!--                                            {{ev.longDescription}}-->
<!--                                        </p>-->
<!--                                        <h5 >LIVE {{getDateReference(ev.start_date, 'live2')}}</h5>-->
<!--                                        &lt;!&ndash;time left in event {{timeLeftInEvent(ev.start_date)}}&ndash;&gt;-->
<!--                                        &lt;!&ndash;<button class="button" type="button" v-if="isUserEntrolled(ev.eventId) && isEventToday(ev.start_date, ev.end_date, ev.eventSwitchTime, getEventSwitchTime) === false"><i class="fa 2x fa-check" aria-hidden="true"></i>&nbsp;Reserved&nbsp;</button>&ndash;&gt;-->
<!--                                        <div v-on:click="calendarLogging($event, ev.title)" title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(ev.eventId)" v-bind:style="{ color: getCorpButtonColor + ' !important', border: '1px solid ' + getCorpButtonColor}">-->
<!--                                            Add to Calendar-->
<!--                                            <span class="start">{{ev.start_date}}</span>-->
<!--                                            <span class="end">{{ev.end_date}}</span>-->
<!--                                            <span class="timezone">ev/New_York</span>-->
<!--                                            <span class="title">{{ev.title}}</span>-->
<!--                                            <span class="description">{{ev.longDescription}}</span>-->
<!--                                            <span class="location">{{eventURL}}/event/{{ev.eventId}}</span>-->
<!--                                        </div>-->
<!--                                        <button v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpEventShareOptnPermission >= 1)" @click="openCorporateImageShareModal(ev)" type="button" class="share-event" v-bind:style="{color: getCorpButtonColor + ' !important', borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: getCorpButtonColor + ' !important'}">-->
<!--                                            <i class="fa fa-share-square-o"></i> Share-->
<!--                                        </button>-->
<!--                                        &lt;!&ndash;<button  class="button" type="button" v-if="showJoin(ev.eventId)" @click="joinEvent(ev)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>&ndash;&gt;-->
<!--                                        &lt;!&ndash;<button v-if="!isUserEntrolled(ev.eventId) && isEventToday(ev.start_date, ev.end_date) === false" @click="enrollUser(ev)" class="button">Reserve your spot</button>&ndash;&gt;-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div id="missed"> archive section will be here</div>-->
                                <div id="missed" v-if="getCorpArchiveEvents" class="clearfix" style="height: 50px;border-bottom: 3px solid #cbcbcb;margin-bottom: 30px;"></div>
                                <div class="col-sm-12" v-if="getCorpArchiveEvents">
                                    <h3 v-if="user.corporation.archiveEventHeading"><strong>{{user.corporation.archiveEventHeading}}</strong></h3>
                                    <div class="clearfix" style="height:30px;"></div>
                                </div>
                                <div class="clearfix" v-if="getCorpArchiveEvents"></div>
                                <div class="sliderEventBox pointer" v-if="getCorpArchiveEvents">
                                    <VueSlickCarousel v-bind="carouselSettings" v-if="getCorpArchiveEvents">
                                        <div class="col-sm-4" v-for="evn in getCorpArchiveEvents">
                                            <div class="show-share-options" v-bind:style="{ backgroundColor: getCorpHeadingColor, 'cursor': 'pointer'}"><img v-bind:src="evn.img_url" class="sliderimage" @click="playVideoArchive(evn.eventId, evn.title)" alt="PRIVATE EVENT BANNER" :title="evn.title" /><div class="favnumbers-a" v-bind:style="{ backgroundColor: getCorpHeaderColor}"><div><span>{{evn.allVidDurInMinutes}}<small>mins</small></span></div><i title="Play" class="fa fa-play-circle-o" @click="playVideoArchive(evn.eventId, evn.title)"></i><i v-if="((user && user.corporation === null) || (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.corpArchiveEventOptnPermission >= 1))" title="Share Playlist" class="fa fa-share-square-o" @click="openCorporateShareModal('event', evn)()"></i></div></div>
                                            <h2 @click="playVideoArchive(evn.eventId, evn.title)">{{evn.title}}</h2>
                                            <p @click="playVideoArchive(evn.eventId, evn.title)">
                                                {{evn.longDescription}}

                                            </p>
                                            <!--<button class="button" type="button" @click="playVideoArchive(evn.eventId, evn.title)"><i class="fa 2x fa-play-circle-o" aria-hidden="true"></i>&nbsp;Play&nbsp;</button>-->
                                            <!--<h5>{{getDateReference(evn.start_date, 'live2')}}</h5>-->
                                            <!--time left in event {{timeLeftInEvent(evn.start_date)}}-->
                                            <!--<span>72 Members | 302 Comments</span>-->
                                            <!--<button class="button" v-if="!isUserEntrolled(evn.eventId) && isEventToday(evn.start_date, evn.end_date) === false" @click="enrollUser(evn)" type="button">Reserve your spot</button>-->
                                            <!--<button  class="btn btn-danger expert-section-btn btn-transparent">Reserve a Seat at the Table</button>-->
                                            <!--<button type="button" class="btn disabled">Coming Soon</button>-->
                                        </div>
                                    </VueSlickCarousel>
<!--                                    <div class="slider responsive-slick-slider">-->
<!--                                        <div class="col-sm-4" v-for="evn in getCorpArchiveEvents" style="cursor: pointer">-->
<!--                                            <img v-bind:src="evn.img_url" class="sliderimage" @click="playVideoArchive(evn.eventId, evn.title)" alt="PRIVATE EVENT BANNER" :title="evn.title" />-->
<!--                                            <h2 @click="playVideoArchive(evn.eventId, evn.title)">{{evn.title}}</h2>-->
<!--                                            <p @click="playVideoArchive(evn.eventId, evn.title)">-->
<!--                                                {{evn.longDescription}}-->

<!--                                            </p>-->
<!--                                            &lt;!&ndash;<button class="button" type="button" @click="playVideoArchive(evn.eventId, evn.title)"><i class="fa 2x fa-play-circle-o" aria-hidden="true"></i>&nbsp;Play&nbsp;</button>&ndash;&gt;-->
<!--                                            &lt;!&ndash;<h5>{{getDateReference(evn.start_date, 'live2')}}</h5>&ndash;&gt;-->
<!--                                            &lt;!&ndash;time left in event {{timeLeftInEvent(evn.start_date)}}&ndash;&gt;-->
<!--                                            &lt;!&ndash;<span>72 Members | 302 Comments</span>&ndash;&gt;-->
<!--                                            &lt;!&ndash;<button class="button" v-if="!isUserEntrolled(evn.eventId) && isEventToday(evn.start_date, evn.end_date) === false" @click="enrollUser(evn)" type="button">Reserve your spot</button>&ndash;&gt;-->
<!--                                            &lt;!&ndash;<button  class="btn btn-danger expert-section-btn btn-transparent">Reserve a Seat at the Table</button>&ndash;&gt;-->
<!--                                            &lt;!&ndash;<button type="button" class="btn disabled">Coming Soon</button>&ndash;&gt;-->
<!--                                        </div>-->
<!--                                    </div>-->
                                </div>
                                <!--<div class="col-sm-6 incaseumi">-->
                                    <!--<img src="https://s3.amazonaws.com/tone-assets/images/events/ToneTues2.png" />-->
                                    <!--<h3>Video Title</h3>-->
                                    <!--<p>Lorium ispm dollar sit amitLorium ispm dollar sit amitLorium ispm dollar sit amit</p>-->
                                <!--</div>-->
                                <!--<div class="col-sm-6 incaseumi">-->
                                    <!--<img src="https://s3.amazonaws.com/tone-assets/images/events/ToneTues2.png" />-->
                                    <!--<h3>Video Title</h3>-->
                                    <!--<p>Lorium ispm dollar sit amitLorium ispm dollar sit amitLorium ispm dollar sit amit</p>-->
                                <!--</div>-->
                                <div class="clearfix" style="height:50px;border-bottom:1px solid #ddd;"></div>
                            </div>
                        </div>
                         <div v-if="selectedTab === 'videos'" class="tabContent" id="tabs-3" :class="{ current: tabs.videos }">
                             <h3 v-if="user.corporation.videoTabHeading"><b>{{user.corporation.videoTabHeading}}</b></h3>
                                 <div class="row yourFaves" v-if="getCorpPrivateVideos">
                                     <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin"  v-for = "video in getCorpPrivateVideos">
                                         <a :href="'/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                             <img class="jw-img" :src="video.image"  :alt="video.title" :title="video.title" />
                                             <p class="text-wrap-title cursor" >
                                                 <i class="fa fa-play-circle-o"></i>
                                                 {{video.title}}
                                             </p>
                                         </a>
                                     </div>
                                 </div>
                    </div>
                         <div v-if="selectedTab === 'playlists' || selectedTab === 'manplaylists' || selectedTab === 'dirplaylists'" class="tabContent" id="tabs-4" :class="{ current: tabs.playlists }">
                        <div class="row video-row plistisrow" v-if="getCorpPlaylists" >
                            <div class="col-sm-12">
                            <h2 v-if="user.corporation.playlistHeading && selectedTab === 'manplaylists'">Horizon's Manager Playlists</h2>
                            <h2 v-if="user.corporation.playlistHeading && selectedTab === 'dirplaylists'">Horizon's Director Playlists</h2>
                            <h2 v-if="user.corporation.playlistHeading && selectedTab === 'playlists'">{{user.corporation.playlistHeading}}</h2>
                            <div class="clearfix" style="height:30px;"></div>
                            </div>
                            <div v-for="playlist in getCorpPlaylists" v-if="playlist.userPlaylistVideos && ((selectedTab === 'playlists' && playlist.playlistCategory === 0) || (selectedTab === 'manplaylists' && (playlist.playlistCategory === 1 || playlist.playlistCategory === 99)) || (selectedTab === 'dirplaylists' && (playlist.playlistCategory === 2 || playlist.playlistCategory === 99)))">
                                <div class="clearfix"></div>
                                <div class="col-sm-6 ">
                                    <div class="pinkbg" v-bind:style="{ backgroundColor: getCorpHeaderColor}" v-if="playlist.userPlaylistVideos && playlist.userPlaylistVideos.length > 0">
                                        <img style="cursor: pointer" :src="playlist.userPlaylistVideos[0].thumbnailURL" @click="playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)" :alt="playlist.title" :title="playlist.title"/>
                                        <div class="pinksidebarmin" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                                            <span class="numb"><strong>{{playlist.userPlaylistVideos.length}}</strong></span>
                                            <i class="fa fa-play-circle-o" @click="playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)"></i>
                                            <i v-if="(user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission >= 1)" title="Share Playlist" class="fa fa-share-square-o" @click="openCorporateShareModal('playlist', playlist)"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 pltext">
                                    <h3 @click="playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)">{{playlist.title}}</h3>
                                    <br>
                                    <p><strong>{{playlist.description}}</strong></p>
                                </div>
                                <div class="clearfix" style="height:10px"></div>

                                    </div>
                            <div class="col-sm-12" v-if="getCropUserSharedVideos">
                                    <hr style="height: 50px;">
                                    <h3>Here are all videos shared with you by your colleagues</h3>
                                    <div class="clearfix" style="height: 50px;"></div>
                                </div>
<div class="clearfix"></div>
                        </div>
                            <div class="row  video-row plistisrow flexwrap">
                                <div class="col-sm-6" v-for="video in getCropUserSharedVideos">
                                    <div class="videoholdersuggestions" v-if="video.playlistId === 0">
                                        <img :src="video.thumbnailURL" @click="setVideoPlayerObject(video.videoCode, video.videoTitle)" :alt="video.videoTitle" :title="video.videoTitle" />
                                        <h3  @click="setVideoPlayerObject(video.videoCode, video.videoTitle)">{{video.videoTitle}}</h3>
                                        <p>Shared by {{video.senderName}}</p>
                                        <p>Message: {{video.messageText}}</p>
                                    </div>
                                    <div class="videoholdersuggestions " v-if="video.playlistId > 0">
                                        <div class="viderowraper-shared" @click="playPlaylistForShared(video)" :class="{'innerimggray': getTrialDays < 0}"> <div class="favnumbers" v-bind:style="{ backgroundColor: getCorpHeaderColor}"><div><span>{{video.playlistDuration}}</span><small>mins</small></div><i title="Play" class="fa fa-play-circle-o"></i></div>
                                            <img :src="video.thumbnailURL" @click="playPlaylistForShared(video)" :alt="video.playlistTitle" :title="video.playlistTitle"/></div>
<!--                                        <img :src="video.thumbnailURL" @click="setVideoPlayerObject(video.videoCode)" :alt="video.playlistTitle" :title="video.playlistTitle" />-->
                                        <h3  @click="playPlaylistForShared(video)">{{video.playlistTitle}}</h3>
                                        <p>Shared by {{video.senderName}}</p>
                                        <p>Message: {{video.messageText}}</p>
                                    </div>
                                </div>

                                <!--<div class="col-sm-6">-->
                                    <!--<div class="videoholdersuggestions">-->
                                        <!--<img src="https://cdn.jwplayer.com/thumbs/XC9MzmHV-720.jpg" />-->
                                        <!--<h3>Video Title here</h3>-->
                                        <!--<p>lorium ispm secondline</p>-->
                                        <!--<p>lorium ispm dollar sit amit lorium ispm dollar sit amit lorium ispm dollar sit amit lorium ispm dollar sit amit lorium ispm dollar sit amit lorium ispm dollar sit amit lorium ispm dollar sit amit </p>-->
                                    <!--</div>-->
                                <!--</div>-->
                        </div>
                    </div>
                    </div>

                </div>
            </div>
        <modal v-if="showCorporateShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateShare" @cancel="cancelCorporateModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a href="javascript:" @click="cancelCorporateModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate" v-if="showShareCommunity">Share with Community</option>
                            <option value="Individual" v-if="showShareIndividual">Share with Colleagues</option>
                            <option value="Friends" v-if="showShareFriends">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
<!--                            <td>-->
<!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
<!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <textarea v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="corpShareModalImage" :alt="corpShareModalTitle" :title="corpShareModalTitle">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${corpShareModalTitle} | TONE Networks`}}</h4>
                        <p> {{`${corpShareModalDesc.substring(0,250)}...`}}</p>
                    </div>
                </div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button v-bind:style="{ backgroundColor: getCorpHeaderColor, border: '1px solid' + getCorpHeaderColor +' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) || (shareInProcess)" @click="shareCorporateVideo()">
                            Share This Playlist
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
        <modal v-if="showCorporateSwitch" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateSwitch" @cancel="cancelCorporateSwitchModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i class="fa fa-exchange"></i> Switch to a different corporation
                <a href="javascript:" @click="cancelCorporateSwitchModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">

                </div>
                <div class="clearfix" style="height: 30px;"></div>
                <h2>{{getParentCorporation.name}}</h2>
                <h5 v-if="getParentCorporation.description">{{getParentCorporation.description}}</h5>
                <div class="row">
                    <div class="col-sm-12 fourinarow">
                        <div class="radio" v-if="siblingCorps" v-for="corp in siblingCorps">
                            <label :class="{ active: selectedCorpId === corp.corporationId }">
                                <span class="heading">{{corp.name}}</span>
                                <div class="embed-responsive embed-responsive-16by9"><img class="thumbnail embed-responsive-item" :src="corp.smallImage ? corp.smallImage : 'https://s3.amazonaws.com/tone-assets/images/corporate/crystal.png'" alt="CORP IMAGE" :title="corp.name"/></div>
                                <input  type="radio" :id="corp.corporationId" :value="corp.corporationId" v-model="selectedCorpId" name="corpSwitch" />
<!--                                <span class="footertext">{{corp.description}}</span>-->
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateSwitchModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button v-bind:style="{ backgroundColor: getCorpHeaderColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="shareInProcess || (selectedCorpId === user.corporation.corporationId)" @click="switchCorporation()">
                            <i class="fa fa-exchange" aria-hidden="true"></i> Switch
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
<!--                <div class="alert alert-default showmobile">-->
<!--                    You are sharing as {{`${user.firstName} ${user.lastName}`}}-->
<!--                </div>-->
            </div>
            <div slot="modal-footer"></div>
        </modal>
        <modal v-if="showCorporateImageShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateImageShare" @cancel="cancelCorporateImageModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a href="javascript:" @click="cancelCorporateImageModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate">Share with Community</option>
                            <option value="Individual">Share with Colleagues</option>
                            <option value="Friends" v-if="shareEventSelected.isPrivate.toString() !== '1'">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
                            <!--                            <td>-->
                            <!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
                            <!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <textarea v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="shareEventSelected.img_url" :alt="shareEventSelected.title" :title="shareEventSelected.title">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${shareEventSelected.title} | TONE Networks`}}</h4>
                        <p> {{`${shareEventSelected.longDescription.substring(0,250)}...`}}</p>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateImageModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button v-bind:style="{ backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess)) " @click="shareCorporateImage()">
                            Share This Event
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
        <modal v-if="showCorporateShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateShare" @cancel="cancelCorporateModal()">
            <div slot="modal-header" class="watchVideoModalHeader" v-bind:style="{ backgroundColor: getCorpHeaderColor}">
                <i class="fa fa-share-square-o"></i> Share with your Corporate Community Or Friends
                <a href="javascript:" @click="cancelCorporateModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate" v-if="showShareCommunity">Share with Community</option>
                            <option value="Individual" v-if="showShareIndividual">Share with Colleagues</option>
                            <option value="Friends" v-if="showShareFriends">Share with Friends</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Friends'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-model="taggedEmails" style="padding-bottom: 10px;"
                                     tag-placeholder="Add this as new email address"
                                     placeholder="Search or add an email address"
                                     label="name"
                                     track-by="name"
                                     :options="emailList"
                                     :multiple="true"
                                     :taggable="true"
                                     @tag="addTag"></multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img v-bind:src="user && user.corporation && user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile-sm.png' : user.picture" alt="user">&nbsp;&nbsp; <b>{{user.firstName.toLowerCase()}}</b>
                            </td>
                            <!--                            <td>-->
                            <!--                                <b>{{user.firstName.toLowerCase()}}</b>-->
                            <!--                            </td>-->
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <textarea v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="corpShareModalImage" :alt="corpShareModalTitle" :title="corpShareModalTitle">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${corpShareModalTitle} | TONE Networks`}}</h4>
                        <p> {{`${corpShareModalDesc.substring(0,250)}...`}}</p>
                    </div>
                </div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button v-bind:style="{ backgroundColor: getCorpHeaderColor, border: '1px solid' + getCorpHeaderColor +' !important'}" class="btn btn-primary btn-pink" :disabled="(shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0 || shareInProcess)) || (shareOption === 'Friends' && (taggedEmails === null || taggedEmails.length === 0 || shareInProcess))" @click="shareCorporateVideo()">
                            Share This Playlist
                            <spinner v-model="shareInProcess" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as {{`${user.firstName} ${user.lastName}`}}
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {spinner, alert, modal} from 'vue-strap'
// import store from '../store'
import $ from 'jquery'
import { dateHelpers } from '../helpers/dateHelpers.js'
import rulescomp from './RulesComp.vue'
import slick from 'slick-carousel'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
export default {
    components: {
        spinner: spinner,
        alert: alert,
        rulescomp,
        modal,
        VueSlickCarousel
    },
    name: 'corporatecommunity',
    metaInfo () {
        let self = this
        return {
            title: self.metaTag_pageTitle,
            meta: [
                {name: 'keywords', content: self.metaTag_keywords},
                {name: 'description', content: self.metaTag_description},
                {property: 'og:image', content: self.metaTag_fb_image},
                {property: 'og:title', content: self.metaTag_fb_title},
                {property: 'og:site_name', content: self.metaTag_fb_sitename},
                {
                    property: 'og:description',
                    content: self.metaTag_fb_description
                },
                {property: 'twitter:title', content: self.metaTag_tw_title},
                {property: 'twitter:card', content: 'summary'},
                {property: 'twitter:image', content: self.metaTag_tw_image},
                {
                    property: 'twitter:description',
                    content: self.metaTag_tw_description
                },
                {property: 'og:image:width', content: '300'},
                {property: 'og:image:height', content: '300'}
            ]
        }
    },
    data: function () {
        return {
            archiveEventId: 0,
            metaTag_pageTitle: '',
            metaTag_description: '',
            metaTag_keywords: '',
            metaTag_fb_image: '',
            metaTag_fb_title: '',
            metaTag_fb_description: '',
            metaTag_fb_sitename: '',
            metaTag_tw_image: '',
            metaTag_tw_title: '',
            metaTag_tw_description: '',
            carouselSettings: {
                'dots': false,
                'infinite': true,
                'speed': 500,
                'slidesToShow': 3,
                'slidesToScroll': 1,
                'initialSlide': 0,
                'responsive': [
                    {
                        'breakpoint': 1024,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'infinite': true,
                            'dots': true
                        }
                    },
                    {
                        'breakpoint': 600,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'initialSlide': 2
                        }
                    },
                    {
                        'breakpoint': 480,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1
                        }
                    }
                ]
            },
            shareImagePayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                eventId: '',
                customizedMessage: '',
                playlistType: 6
            },
            shareEventSelected: null,
            showCorporateImageShare: false,
            selectedCorpId: 0,
            siblingCorps: null,
            taggedEmails: [],
            emailList: [],
            showShareCommunity: false,
            showShareIndividual: false,
            showShareFriends: false,
            toggleSpinner: false,
            contentToSearch: '',
            privateEventURL: window.location.href,
            pageLimit: 6,
            pageStart: 1,
            pageEnd: 6,
            enteredValue: '',
            spinner: false,
            isBlankField: false,
            isEmptyResponse: false,
            showCorporateSwitch: false,
            currentPlan: '',
            signUpPath: '',
            tabs: {
                community: false,
                events: false,
                playlists: false,
                videos: false,
                manplaylists: false,
                dirplaylists: false
            },
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            isNativeApp: false,
            showCorporateShare: false,
            selectedCorps: null,
            corporateShareMessage: '',
            selectedTab: '',
            shareOption: 'Corporate',
            topImage: 'https://s3.amazonaws.com/tone-assets/images/resources/GettyImages-863497498-min.jpg',
            smallImage: 'https://s3.amazonaws.com/tone-assets/images/resources/4th-of-july-blur-bokeh-450301.jpg',
            spotlightImage: 'https://s3.amazonaws.com/tone-assets-prod/images/team/Pippa-Schwarzkopf-Editor.png',
            eventURL: 'https://www1.dev-tonenetworks.com',
            corpShareModalImage: '',
            corpShareModalDesc: '',
            corpShareModalTitle: '',
            corporateInfo: null,
            selectedPlaylist: null,
            shareInProcess: false,
            shareVideoPayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                recipientFriendEmails: null,
                playlistId: '',
                messageText: '',
                playlistType: 3
            }
        }
    },
    mounted () {
        let self = this
        if (this.user && (this.user.corporation && this.user.corporation.enableCorporatePage === 1)) {
            this.selectedCorpId = this.user.corporation.corporationId
            this.topImage = this.user.corporation.largeImage ? this.user.corporation.largeImage : 'https://s3.amazonaws.com/tone-assets/images/corporate/Image1.png'
            this.smallImage = this.user.corporation.smallImage ? this.user.corporation.smallImage : 'https://s3.amazonaws.com/tone-assets/images/resources/4th-of-july-blur-bokeh-450301.jpg'
        } else {
            // Redirect user if corporation is not enabled
            this.$router.push('/mytone')
        }
        console.log('1 -> CororateCommunity.vue -> mounted () -> ')
        self.$store.dispatch('GETDYNAMICCONTENTS', 30).then(() => {
            if (self.getAllSiteContents) {
                // Load Meta Tags
                this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                // OpenGraph Tags
                this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                // Twitter Tags
                this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
            }
        })
        this.$store.dispatch('GETALLEXPERTS').then(() => {
        })
        this.$store.dispatch('GETCORPEVENTS', this.user.corporation.corporationId).then(() => {
            if (this.getCorpAllEvents) {
                this.calculateTimeToStartEvent(this.getCorpMainEvent.start_date, this.getCorpMainEvent.end_date, this.getCorpMainEvent.eventSwitchTime, this.getEventSwitchTime)
                // console.log('all events fetched', this.getCorpAllEvents)
            }
        })
        this.$store.dispatch('GETCORPEVENTSARCHIVE', this.user.corporation.corporationId).then(() => {
            if (this.getCorpArchiveEvents) {
//                console.log('archive events', this.getCorpArchiveEvents)
            }
        })
        this.$store.dispatch('GET_PARENT_CORPORATION', this.user.corporation.corporationId).then(() => {
            if (this.getParentCorporation) {
                // console.log('parent corp', this.getParentCorporation.lstCorporation.length)
                if (this.getParentCorporation.lstCorporation && this.getParentCorporation.lstCorporation.length >= 1) {
                    // console.info('inside parenty')
                    this.siblingCorps = this.getParentCorporation.lstCorporation
                    // console.log('sibligs', this.siblingCorps)
                }
            }
        })
        this.$store.dispatch('GETCORPPRIVATEVIDEOS', this.user.corporation.corporationId).then(() => {
            if (this.getCorpPrivateVideos) {
//                console.log('archive events', this.getCorpArchiveEvents)
            }
        })
        this.$store.dispatch('GETCORPORATIONPINNEDMSGS', this.user.corporation.corporationId).then(() => {
            if (this.getCorporationPinnedMsgs) {
//                console.log('corp Pinned Msgs', this.getCorporationPinnedMsgs)
            }
        })
        this.$store.dispatch('GETCORPPLAYLISTS', this.user.corporation.corporationId).then(() => {
            if (this.getCorpPlaylists) {
                // console.log('corp Playlists', this.getCorpPlaylists)
            }
        })
        this.$store.dispatch('GETCORPSHAREDVIDEOS', this.user.userId).then(() => {
            if (this.getCropUserSharedVideos) {
//                console.log('corp shared videos', this.getCropUserSharedVideos)
            }
        })
        // Get Corporatin Payload if user is part of corporation
        this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(() => {
            this.allCorps = []
            if (this.getCorporatePayload) {
                this.corporateInfo = this.getCorporatePayload
                this.allCorps = this.corporateInfo.lstCorporationUsers
            }
        })
        // Get Tagged Email List
        this.$store.dispatch('GET_TAGGED_EMAIL_LIST', this.user.userId).then(() => {
            if (this.getTaggedEmailList) {
                this.emailList = []
                this.emailList = this.getTaggedEmailList
                console.log('email list', self.getTaggedEmailList)
            }
        })
        this.selectedTab = 'community' // defaultCorpTab
        if (this.$route.params.tab) {
            console.log('default tab', this.user.corporation)
            setTimeout(() => {
                let tab = this.$route.params.tab
                if (tab === 'career' || tab === 'coaching') {
                    this.selectedTab = 'events'
                } else if (tab === 'playlists') {
                    console.info('inside playlists')
                    if (this.getCorpPlaylists) {
                        this.selectedTab = 'playlists'
                        console.log('playlist set')
                    } else {
                        this.selectedTab = 'events'
                    }
                } else if (tab === 'videos') {
                    if (this.getCorpPrivateVideos) {
                        this.selectedTab = 'videos'
                    } else {
                        this.selectedTab = 'events'
                    }
                } else if (tab === 'community') {
                    if (this.user.corporation.showSpotlightSection || this.user.corporation.showPinnedMessages) {
                        this.selectedTab = 'community'
                    } else {
                        this.selectedTab = 'events'
                    }
                } else {
                    this.selectedTab = 'events'
                }
            }, 800)
        } else {
            console.log('selected tab', this.user.corporation.defaultCorpTab)
            setTimeout(() => {
                let tab = this.user.corporation.defaultCorpTab
                if (tab === 1) {
                    this.selectedTab = 'events'
                } else if (tab === 3) {
                    if (this.getCorpPlaylists) {
                        this.selectedTab = 'playlists'
                    } else {
                        this.selectedTab = 'events'
                    }
                } else if (tab === 4) {
                    if (this.getCorpPrivateVideos) {
                        this.selectedTab = 'videos'
                    } else {
                        this.selectedTab = 'events'
                    }
                } else if (tab === 2) {
                    if (this.user.corporation.showSpotlightSection || this.user.corporation.showPinnedMessages) {
                        this.selectedTab = 'community'
                    } else {
                        this.selectedTab = 'events'
                    }
                } else {
                    this.selectedTab = 'events'
                }
            }, 800)
        }
        setTimeout(() => {
            if ((this.selectedTab === 'events' || this.selectedTab === 'career') && this.$route.params.section === 'in-case-you-missed-it' && this.getCorpArchiveEvents) {
                $('html,body').animate({ scrollTop: $('#missed').offset().top }, 800)
            }
        }, 1000)
    },
    watch: {
        'showCorporateShare' (to, from) {
            let self = this
            if (self.showCorporateShare) {
                self.selectedCorps = null
                self.corporateShareMessage = ''
                self.taggedEmails = []

                // self.shareOption = 'Corporate'
            }
        },
        'selectedTab' (to, from) {
            if (this.selectedTab === 'events') {
                // setTimeout(() => {
                //     this.createCarousal()
                // }, 1500)
                setTimeout(function () {
                    window.addeventatc.refresh()
                }, 2500)
            }
        },
        'shareOption' (to, from) {
            let self = this
            self.selectedCorps = null
            self.corporateShareMessage = ''
//            self.corpShareModalImage = ''
//            self.corpShareModalDesc = ''
//            self.corpShareModalTitle = ''
        }
    },
    methods: {
        replaceLastExpert (strArray, chr, newChr) {
            var a = strArray.split('')
            a[strArray.lastIndexOf(chr)] = newChr
            return a.join('').replace('/,/g', ', ')
        },
        setDynamicSection (coll, key) {
            let valCol = coll.filter(x => {
                return x.content_id === key
            })
            if (valCol && valCol.length > 0) {
                return valCol[0].content_value
            } else {
                return ''
            }
        },
        playPlaylistForShared (playlistObj) {
            if (this.getTrialDays < 0) {
                this.$router.push(`/becomemember`)
            } else {
                if (playlistObj.playlistType === 1) {
                    this.$router.push(`/playlist/${playlistObj.playlistId}/play/${playlistObj.videoCode}`)
                } else if (playlistObj.playlistType === 2) {
                    this.$router.push(`/playlist/trending/${playlistObj.playlistId}/play/${playlistObj.videoCode}/${playlistObj.videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
                } else if (playlistObj.playlistType === 3) {
                    this.$router.push(`/playlist/${playlistObj.playlistId}/play/${playlistObj.videoCode}/${this.user.corporation.corporationId}/${playlistObj.playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
                } else if (playlistObj.playlistType === 4) {
                    // this.$router.push(`/tonearchive/${eventId}/play/1/${eventTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
                } else {

                }
            }
        },
        get_regular_tagged_colleagues () {
            let self = this
            // Get corporation Payload if user is part of corporation
            self.$store.dispatch('GETCORPPAYLOAD', self.user.userId).then(() => {
                self.allCorps = []
                if (self.getCorporatePayload) {
                    self.corporateInfo = self.getCorporatePayload
                    self.allCorps = self.corporateInfo.lstCorporationUsers
                }
            })
        },
        get_private_tagged_colleagues () {
            let self = this
            // Get corporation Payload if user is part of corporation
            self.$store.dispatch('GETCORPPAYLOAD_PRIVATE_EVENT_SHARING', self.user.userId).then(() => {
                self.allCorps = []
                if (self.getCorporatePayload) {
                    self.corporateInfo = self.getCorporatePayload
                    self.allCorps = self.corporateInfo.lstCorporationUsers
                }
            })
        },
        shareCorporateImage () {
            let self = this
            self.shareImagePayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
            self.shareImagePayload.senderUserId = self.user.userId
            self.shareImagePayload.recipientsUserIds = []
            self.shareImagePayload.recipientFriendEmails = null
            self.shareImagePayload.customizedMessage = self.corporateShareMessage
            if (self.shareOption === 'Corporate') {
                self.shareImagePayload.recipientsUserIds = []
                self.shareImagePayload.recipientFriendEmails = null
            } else if (self.shareOption === 'Individual') {
                self.shareImagePayload.recipientFriendEmails = null
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareImagePayload.recipientsUserIds = self.selectedCorps.map(x => {
                        return x.userId
                    })
                }
            } else if (self.shareOption === 'Friends') {
                self.shareImagePayload.recipientsUserIds = []
                let emailArray = self.taggedEmails.map(x => {
                    return x.name
                })
                self.shareImagePayload.recipientFriendEmails = emailArray.join(',')
            } else {
            }
            self.shareImagePayload.eventId = self.shareEventSelected.eventId
            self.shareInProcess = true
            // Send the Email
            self.$store.dispatch('CORP_EVENT_SHARE', {payload: self.shareImagePayload}).then(() => {
                if (!self.error.show) {
                    self.spinnerToggle()
                    self.$swal({
                        title: 'Event has been shared!',
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(
                        function () {
                        },
                        // handling the promise rejection
                        function (dismiss) {
                            if (dismiss === 'timer') {
                            }
                        }
                    )
                    // self.shareInProcess = false
                    // self.spinnerToggle()
                    self.cancelCorporateImageModal()
                } else {
                    // self.shareInProcess = false
                    // self.spinnerToggle()
                    self.cancelCorporateImageModal()
                }
            })
        },
        openCorporateImageShareModal (tEvent) {
            console.log('event for share', tEvent)
            let self = this
            if (tEvent.isPrivate.toString() === '1') {
                self.get_private_tagged_colleagues()
            } else {
                self.get_regular_tagged_colleagues()
            }
            self.shareInProcess = false
            self.shareEventSelected = tEvent
            self.corpShareModalImage = tEvent.img_url
            self.corpShareModalDesc = tEvent.description
            self.corpShareModalTitle = tEvent.title
            self.showCorporateImageShare = true
        },
        cancelCorporateImageModal () {
            $('html').removeClass('model-open')
            var self = this
            window.setTimeout(function () {
                self.showCorporateImageShare = false
                self.archiveEventId = 0
                self.shareInProcess = false
                $('.modal-open').removeClass('modal-open')
            }, 500)
        },
        addTag (newTag) {
            let self = this
            console.log('newTAg', newTag)
            const tag = {
                name: newTag
            }
            if (self.verifyEmailShare(newTag)) {
                self.emailList.push(tag)
                self.taggedEmails.push(tag)
                console.log('tagged emails', this.taggedEmails)
            } else {
                console.log('invalid email address, calling swal')
            }
        },
        verifyEmailShare (email) {
            if (email.length > 0) {
                let re = /\S+@\S+\.\S+/
                if (!re.test(email)) {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },
        switchCorporation () {
            let self = this
            self.shareInProcess = true
            self.$store.dispatch('SWITCH_CORPORATION', self.selectedCorpId).then(() => {
                if (self.getSwitchCorporateClient) {
                    self.shareInProcess = false
                    self.$swal({
                        title: `Corporation Successfully switched to : ${self.getSwitchCorporateClient.name}`,
                        text: '',
                        type: 'success',
                        timer: 3000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(
                        function () {
                        },
                        // handling the promise rejection
                        function (dismiss) {
                            if (dismiss === 'timer') {
                                window.location.reload()
                            }
                        }
                    )
                    self.$router.push('/mytone')
                } else {
                    self.shareInProcess = false
                }
            })
        },
        openSwitchModal () {
            console.log('user definition', this.user.corporation.corporationId)
            this.selectedCorpId = this.user.corporation.corporationId
            this.showCorporateSwitch = true
        },
        handleCorporateShareModal () {
            let self = this
            self.showCorporateShare = true
            // Set up user rights
            if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission >= 1) {
                let rights = self.user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission
                console.log('rights', rights)
                if (rights === 1) {
                    self.showShareCommunity = true
                    self.showShareIndividual = true
                } else if (rights === 2) {
                    self.showShareCommunity = true
                    self.showShareIndividual = false
                    self.shareOption = 'Corporate'
                    self.showCorporateShare = true
                } else if (rights === 3) {
                    self.showShareCommunity = false
                    self.showShareIndividual = true
                    self.shareOption = 'Individual'
                } else {
                    self.showShareCommunity = false
                    self.showShareIndividual = false
                }
            }
        },
        calendarLogging (event, title) {
            // console.log('event was fired', event)
            // console.log('event title', title)
            let self = this
            let userPayload = []
            let uId = 0
            if (self.user) {
                uId = self.user.userId
            }
            userPayload.push(uId)
            userPayload.push(self.$route.fullPath)
            userPayload.push('ADD_TO_CALENDAR')
            userPayload.push(title)
            self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload)
        },
        maskEmailAddress (userEmail) {
            let avg, splitted, part1, part2
            splitted = userEmail.split('@')
            part1 = splitted[0]
            let regex = /[^0-9.]/g
            let maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1)
            console.log('maked', maskid)
            avg = part1.length / 2
            part1 = part1.substring(0, (part1.length - avg))
            part2 = splitted[1]
            let maskDomain = part2.split('.')
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1]
        },
        openCorporateShareModal (type, playlistObj) {
            let self = this
            self.get_regular_tagged_colleagues()
            self.shareInProcess = false
            if (type === 'playlist') {
                self.corpShareModalImage = playlistObj.userPlaylistVideos[0].thumbnailURL
                self.corpShareModalDesc = playlistObj.description
                self.corpShareModalTitle = playlistObj.title
                self.selectedPlaylist = playlistObj
                self.archiveEventId = 0
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission >= 1) {
                    let rights = self.user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission
                    if (rights === 1) {
                        self.showShareCommunity = true
                        self.showShareIndividual = true
                        self.showShareFriends = true
                    } else if (rights === 2) {
                        self.showShareCommunity = true
                        self.showShareIndividual = false
                        self.showShareFriends = false
                        self.shareOption = 'Corporate'
                    } else if (rights === 3) {
                        self.showShareCommunity = false
                        self.showShareFriends = false
                        self.showShareIndividual = true
                        self.shareOption = 'Individual'
                    } else if (rights === 5) {
                        self.showShareCommunity = false
                        self.showShareIndividual = false
                        self.showShareFriends = true
                        self.shareOption = 'Friends'
                    } else {
                        self.showShareCommunity = false
                        self.showShareIndividual = false
                        self.showShareFriends = false
                    }
                }
            } else {
                self.corpShareModalImage = playlistObj.img_url
                self.corpShareModalDesc = playlistObj.description
                self.corpShareModalTitle = playlistObj.title
                self.selectedPlaylist = playlistObj
                self.archiveEventId = playlistObj.eventId
                if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.corpArchiveEventOptnPermission >= 1) {
                    // let rights = self.user.corporation.corpSharingPermissions.corpArchiveEventOptnPermission
                    self.showShareCommunity = true
                    self.showShareIndividual = true
                    self.showShareFriends = false
                }
            }
            self.showCorporateShare = true
            // Set up user rights
            // if (self.user && self.user.corporation && self.user.corporation.corpSharingPermissions && self.user.corporation.corpSharingPermissions.corpArchiveEventOptnPermission >= 1) {
            //     let rights = self.user.corporation.corpSharingPermissions.shareCompanyPlaylistPermission
            //     if (rights === 1) {
            //         self.showShareCommunity = true
            //         self.showShareIndividual = true
            //         self.showShareFriends = true
            //     } else if (rights === 2) {
            //         self.showShareCommunity = true
            //         self.showShareIndividual = false
            //         self.showShareFriends = false
            //         self.shareOption = 'Corporate'
            //     } else if (rights === 3) {
            //         self.showShareCommunity = false
            //         self.showShareFriends = false
            //         self.showShareIndividual = true
            //         self.shareOption = 'Individual'
            //     } else if (rights === 5) {
            //         self.showShareCommunity = false
            //         self.showShareIndividual = false
            //         self.showShareFriends = true
            //         self.shareOption = 'Friends'
            //     } else {
            //         self.showShareCommunity = false
            //         self.showShareIndividual = false
            //         self.showShareFriends = false
            //     }
            // }
        },
        shareCorporateVideo () {
            let self = this
            self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
            self.shareVideoPayload.senderUserId = self.user.userId
            self.shareVideoPayload.recipientsUserIds = []
            self.shareVideoPayload.recipientFriendEmails = null
            self.shareVideoPayload.messageText = self.corporateShareMessage
            if (self.shareOption === 'Corporate') {
                self.shareVideoPayload.recipientsUserIds = []
                self.shareVideoPayload.recipientFriendEmails = null
            } else if (self.shareOption === 'Individual') {
                self.shareVideoPayload.recipientFriendEmails = null
                if (self.selectedCorps && self.selectedCorps.length > 0) {
                    self.shareVideoPayload.recipientsUserIds = self.selectedCorps.map(x => {
                        return x.userId
                    })
                }
            } else if (self.shareOption === 'Friends') {
                self.shareVideoPayload.recipientsUserIds = []
                let emailArray = self.taggedEmails.map(x => {
                    return x.name
                })
                self.shareVideoPayload.recipientFriendEmails = emailArray.join(',')
            } else {
            }
            let sharingMsg = 'Playlist has been shared!'
            if (self.archiveEventId > 0) {
                self.shareVideoPayload.playlistId = self.selectedPlaylist.eventId
                self.shareVideoPayload.playlistType = 7
                sharingMsg = 'Archive Playlist has been shared!'
            } else {
                self.shareVideoPayload.playlistId = self.selectedPlaylist.playlistId
                // playlistType = 6 ===> corporation playlist is shared from Corporate Community page
                self.shareVideoPayload.playlistType = 6
                sharingMsg = 'Playlist has been shared!'
            }
            // self.shareVideoPayload.playlistId = self.selectedPlaylist.playlistId
            // self.shareInProcess = true  commented on 09/01/2021

            // Send the Email
            console.log('updated sharing payload', self.shareVideoPayload)
            if (!self.shareInProcess) {
                self.$store.dispatch('PLAYLISTCORPORATESHARE', {payload: self.shareVideoPayload}).then(() => {
                    if (!self.error.show) {
                        self.spinnerToggle()
                        self.$swal({
                            title: sharingMsg,
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateModal()
                    } else {
                        // self.shareInProcess = false
                        // self.spinnerToggle()
                        self.cancelCorporateModal()
                    }
                })
            }
            self.shareInProcess = true
        },
        customLabel (option) {
            let findDuplicate = this.allCorps.find(x => {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId
            })
//            console.log('findDuplicate', findDuplicate)
            if (findDuplicate) {
                let maskedEmail = this.maskEmailAddress(option.email)
                return `${option.firstName} ${option.lastName} <${maskedEmail}>`
            } else {
                return `${option.firstName} ${option.lastName}`
            }
        },
        cancelCorporateModal () {
            $('html').removeClass('model-open')
            var self = this
            window.setTimeout(function () {
                self.showCorporateShare = false
                self.shareInProcess = false
                $('.modal-open').removeClass('modal-open')
            }, 500)
        },
        cancelCorporateSwitchModal () {
            $('html').removeClass('model-open')
            var self = this
            window.setTimeout(function () {
                self.showCorporateSwitch = false
                self.shareInProcess = false
                $('.modal-open').removeClass('modal-open')
            }, 500)
        },
        getMinutesBetweenDates (startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime()
            return (diff / 60000)
        },
        setVideoPlayerObject (videoCode, videoTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push(`/becomemember`)
            } else {
                this.$router.push(`/watch/${videoCode}/${videoTitle.replace(/\\s/g, '-').toLowerCase()}`)
            }
        },
        playPlaylist (playlistId, videoCode, playlistTitle) {
            let self = this
            if (self.getTrialDays < 0) {
                self.$router.push(`/becomemember`)
            } else {
                let userPayload = []
                let uId = 0
                if (self.user) {
                    uId = self.user.userId
                }
                userPayload.push(uId)
                userPayload.push(self.$route.fullPath)
                userPayload.push('CORP_PLAYLIST_CLICK')
                userPayload.push(playlistTitle)
                self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload)
                this.$router.push(`/playlist/${playlistId}/play/${videoCode}/${this.user.corporation.corporationId}/${playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
            }
        },
        playVideoArchive (eventId, eventTitle) {
            let self = this
            let userPayload = []
            let uId = 0
            if (self.user) {
                uId = self.user.userId
            }
            userPayload.push(uId)
            userPayload.push(self.$route.fullPath)
            userPayload.push('CORP_ARHIVE_CLICK')
            userPayload.push(eventTitle)
            self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload)
            this.$router.push(`/tonearchive/${eventId}/play/1/${eventTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
            // location.reload()
        },
        createCarousal () {
            if (this.selectedTab === 'events') {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: false
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }, {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }]
                })
            }
        },
        getExpertInfo (expertId, info) {
            let reqInfo
            if (this.getAllExperts) {
                let expert = this.getAllExperts.filter(exp => {
                    return exp.expertId === expertId
                })
                if (info === 'name') {
                    reqInfo = expert[0].name
                } else if (info === 'img') {
                    reqInfo = expert[0].small_image
                } else if (info === 'biography') {
                    reqInfo = expert[0].biography
                } else if (info === 'experties') {
                    reqInfo = expert[0].experties
                }
            }
            return reqInfo
        },
        isEventToday (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            // console.log('1st switch time', defaultSwitchTime)
            let eventDate = new Date(evtDate)
            let eventEndDate = new Date(endDate)
            let currentDate = this.returnEasternTime()
            let switchTime = parseInt(defaultSwitchTime)
            // console.log('switch time', switchTime)
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime)
            }
            // console.log('new switch time', switchTime)
            // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                // console.log('event is today', switchTime)
                // console.log('time in event', this.getMinutesBetweenDates(currentDate, eventDate))
                // console.log('condition 1 status', this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime)
                // console.log('condition 2 status', this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0)
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    // console.log('true for event starting at', evtDate)
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
            // let eventDate = new Date(evtDate)
            // let eventEndDate = new Date(endDate)
            // let currentDate = this.returnEasternTime()
            // let switchTime = parseInt(defaultSwitchTime)
            // if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
            //     switchTime = parseInt(eventSwtichTime)
            // }
            // // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
            // if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
            //     if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
            //         return true
            //     } else {
            //         return false
            //     }
            // } else {
            //     return false
            // }
        },
        getDateReference (dte, type) {
            let dt = new Date(dte)
            let dayStr, monStr
            let eDay = dt.getDate()
            let eHours = this.getHoursFormatted(dt)
            let pHours = this.getPacificTime(dt)
            let eMonth = dt.getMonth() + 1
            let day
            // Set Day of Date
            if (dt.getDay() === 0) {
                day = 'Sunday'
            } else if (dt.getDay() === 1) {
                day = 'Monday'
            } else if (dt.getDay() === 2) {
                day = 'Tuesday'
            } else if (dt.getDay() === 3) {
                day = 'Wednesday'
            } else if (dt.getDay() === 4) {
                day = 'Thursday'
            } else if (dt.getDay() === 5) {
                day = 'Friday'
            } else if (dt.getDay() === 6) {
                day = 'Saturday'
            } else {
                day = ''
            }
            // Set Date Pattern
            if (eDay === 1) {
                dayStr = '1st'
            } else if (eDay === 2) {
                dayStr = '2nd'
            } else if (eDay === 3) {
                dayStr = '3rd'
            } else if (eDay === 21) {
                dayStr = '21st'
            } else if (eDay === 22) {
                dayStr = '22nd'
            } else if (eDay === 23) {
                dayStr = '23rd'
            } else if (eDay === 31) {
                dayStr = '31st'
            } else {
                dayStr = eDay + 'th'
            }
            // Set Month
            if (eMonth === 1) {
                monStr = 'January'
            } else if (eMonth === 2) {
                monStr = 'February'
            } else if (eMonth === 3) {
                monStr = 'March'
            } else if (eMonth === 4) {
                monStr = 'April'
            } else if (eMonth === 5) {
                monStr = 'May'
            } else if (eMonth === 6) {
                monStr = 'June'
            } else if (eMonth === 7) {
                monStr = 'July'
            } else if (eMonth === 8) {
                monStr = 'August'
            } else if (eMonth === 9) {
                monStr = 'September'
            } else if (eMonth === 10) {
                monStr = 'October'
            } else if (eMonth === 11) {
                monStr = 'November'
            } else if (eMonth === 12) {
                monStr = 'December'
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
            } else if (type === 'live') {
                return monStr + ' ' + eDay
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT'
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET' + ' / ' + pHours + ' PT'
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET' + ' / ' + pHours + ' PT'
            }
        },
        returnEasternTime () {
            let offset = -5
            if (dateHelpers.dstEnabled(new Date())) {
                offset = -4.0
            }
            let clientDate = new Date()
            let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
            let serverDate = new Date(utc + (3600000 * offset))
            return serverDate
        },
        showJoin (eventId) {
            let event = this.getCorpAllEvents.filter(evn => {
                return evn.eventId === eventId
            })
            if (this.isEventToday(event[0].start_date, event[0].end_date, event[0].eventSwitchTime, this.getEventSwitchTime)) {
                return true
            }
            return false
        },
        getHoursFormatted (time) {
            let hours = time.getHours()
            let minutes = time.getMinutes()
            let ampm = hours >= 12 ? 'pm' : 'am'
            hours = hours % 12
            hours = hours === 0 ? '12' : hours
            minutes = minutes < 10 ? '0' + minutes : minutes
            let strTime = minutes > 0 ? hours + ':' + minutes + ' ' + ampm : hours + ' ' + ampm
            return strTime
        },
        getPacificTime (time) {
            let hours = time.getHours() - 3
            let minutes = time.getMinutes()
            let ampm = hours >= 12 ? 'p.m.' : 'a.m.'
            hours = hours % 12
            hours = hours === 0 ? '12' : hours
            minutes = minutes < 10 ? '0' + minutes : minutes
            let strTime = minutes > 0 ? hours + ':' + minutes + ' ' + ampm : hours + ' ' + ampm
            return strTime
        },
        switchTab: function (id) {
            console.log('==============================================================================================================================> = id = ', id)
            let self = this
            let tabName = id
            if (id === 'events') {
                tabName = 'coaching events'
            }
            let userPayload = []
            let uId = 0
            if (self.user) {
                uId = self.user.userId
            }
            userPayload.push(uId)
            userPayload.push(self.$route.fullPath)
            userPayload.push('MY_COMMUNITY_TAB_CHANGED')
            userPayload.push(tabName)
            self.$store.dispatch('LOG_USER_WITHIN_PAGE_CLICK', userPayload)
            self.selectedTab = id
            console.log('==============================================================================================================================> = self.selectedTab = ', self.selectedTab)
            for (let tab in self.tabs) {
                this.tabs[tab] = id === tab
            }
            console.log('==============================================================================================================================> = this.tabs = ', this.tabs)
        },
        redirectToSignUp () {
            if (this.getMarketingPlan) {
                this.$router.push('/signup/' + this.getMarketingPlan)
            } else {
                this.$router.push('/signup')
            }
        },
        initiateSearch () {
            this.pageStart = 1
            this.pageEnd = 6
            if (this.contentToSearch.length !== 0) {
                this.enteredValue = this.contentToSearch
                this.isBlankField = false
                this.isEmptyResponse = false
                this.spinnerToggle()
                this.$store.dispatch('GETSEARCHRESULTS', this.contentToSearch).then(() => {
                    window.logEvents('Search Page', 'click', `Title Searched: ${this.contentToSearch}`)
                    if (this.getSearchResults['length'] !== 0) {
//                        console.log('results', this.getSearchResults['length'], this.getSearchResults)
                    } else {
                        this.isEmptyResponse = true
                    }
                    this.spinnerToggle()
                })
            } else {
                this.$swal({
                    title: 'Please type something, the input field seems to be blank.',
                    text: '',
                    type: 'question',
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(
                    function () {
                    },
                    // handling the promise rejection
                    function (dismiss) {
                        if (dismiss === 'timer') {
                        }
                    }
                )
               // this.isBlankField = true
            }
        },
        spinnerToggle () {
            this.spinner = !this.spinner
        },
        limitTo (arr) {
            return arr.slice(this.pageStart - 1, this.pageEnd)
        },
        getVideoStatus (videoObject) {
            if (this.getAuthUserVideos) {
                let mediaId = videoObject.mediaid
                let exists = this.getAuthUserVideos.filter(videoObject => {
                    return videoObject.videoCode === mediaId
                })
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        setVideoStatus (videoObject) {
            if (this.getAuthUserVideos) {
                let mediaId = videoObject.mediaid
                let exists = this.getAuthUserVideos.filter(videoObject => {
                    return videoObject.videoCode === mediaId
                })
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0'
                    } else {
                        exists[0].liked = '1'
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(() => {
                        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                    })
                } else {
                    let logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                    })
                }
            }
        },
        setPlaylistVideoStatus (video, playlist, currentStatus) {
            let self = this
            self.selectedVideo = video.mediaid
            self.selectedPlaylist = playlist.playlistId
            if (currentStatus) { // Video is unSelected
                let payload = {}
                payload.videoCode = video.mediaid
                payload.userPlaylistId = playlist.playlistId
                payload.userId = this.user.userId
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                    self.videoAdded = false
                    self.videoRemoved = true
                })
            } else { // Video is Selected
                let payload = {}
                payload.videoCode = video.mediaid
                payload.userId = this.user.userId
                payload.userPlaylistId = playlist.playlistId
                this.$store.dispatch('ADDVIDEOINPLAYLIST', {playlist: payload}).then(() => {
                    // this.charities = this.getAuthUserVideos
                    self.videoAdded = true
                    self.videoRemoved = false
                })
            }
            setTimeout(() => {
                self.videoAdded = false
                self.videoRemoved = false
            }, 1500)
        },
        verifyPlaylistExists () {
            if (this.getUserPlaylists) {
                let playlistsWithVideo = this.getUserPlaylists.filter(x => {
                    return x.userPlaylistVideos !== null
                })
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        verifyVideoExists (playlist, video) {
            let self = this
            if (this.getUserPlaylists) {
                let findPlaylist = this.getUserPlaylists.filter(x => {
                    return x.playlistId === playlist.playlistId
                })
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        let videos = findPlaylist[0].userPlaylistVideos.filter(x => {
                            return x.videoCode === video.mediaid
                        })
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true
                            return true
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        addNewPlayList () {
            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                let payload = {}
                payload.userId = this.user.userId
                payload.title = this.newPlaylistName
                this.$store.dispatch('CREATEPLAYLIST', {playlist: payload}).then(() => {
                    this.newPlaylistName = ''
                    // this.charities = this.getAuthUserVideos
                })
            }
        },
        showPlaylistMenu (videoCode) {
            // console.log(videoCode)
            $('#' + videoCode + ' + ul').toggleClass('hide')
        },
        hidePlaylistMenu (videoCode) {
            // console.log(videoCode)
            $('#' + videoCode + ' + ul').toggleClass('hide')
        },
        calculateTimeToStartEvent (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            // let self = this
            let eventDate = new Date(evtDate)
            let currentDate = this.returnEasternTime()
            let switchTime = parseInt(defaultSwitchTime)
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime)
            }
            // console.log('time left in event', this.getMinutesBetweenDates(currentDate, eventDate))
            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime) {
                    // console.log('event joining enabled')
                } else {
                    // console.log('difference', self.getMinutesBetweenDates(currentDate, eventDate))
                    // console.log('switch time', switchTime)
                    // console.log('time left', self.getMinutesBetweenDates(currentDate, eventDate) - switchTime)
                    let timeToStart = this.getMinutesBetweenDates(currentDate, eventDate) - switchTime
                    if (timeToStart > 0 && timeToStart <= 90) {
                       // console.log('view needs to be freshed after: ', timeToStart)
                        let timeToTrigger = parseInt(timeToStart * 60 * 1000)
                        // console.log('trigger in seconds', timeToTrigger)
                        setTimeout(() => {
                            if (this.$route.name === 'CorporateCommunity') {
                                window.location.reload()
                            }
                        }, timeToTrigger + 60)
                    }
                }
            }
        },
        getCurrentRoute () {
            console.log('this.$route = ', this.$route)
            console.log('this.$route.name = ', this.$route.name)
            //            if (this.$route.name === 'Redeem,') {
            //                console.log('yes')
            //            }
            return this.$route
        },
        buildEventLink (EVENT_ID) {
            let href = window.location.href
            let calendarLink = ''
            console.log('Community.vue -> buildEventLink() : href = ', href)
            console.log('Community.vue -> buildEventLink() : EVENT_ID = ', EVENT_ID)
            if (this.user && this.user.corporation && this.user.corporation.corporationId === 200) {
                if (href.indexOf('localhost') > -1 || href.indexOf('dev') > -1) {
                    calendarLink = 'https://www1.dev-tonenetworks.com/horizonssotest?corporationId=200&redirect_uri=https://www1.dev-tonenetworks.com/event/' + EVENT_ID // this.getMainEvent.eventId
                } else {
                    calendarLink = 'https://www.tonenetworks.com/horizonsso?corporationId=200&redirect_uri=https://www.tonenetworks.com/event/' + EVENT_ID // this.getMainEvent.eventId
                }
                //  https://www.tonenetworks.com/horizonsso?corporationId=200&redirect_uri=https://www.tonenetworks.com/event/294
            } else {
                calendarLink = this.eventURL + '/event/' + EVENT_ID // this.getMainEvent.eventId
                // https://www.tonenetworks.com/event/294
            }
            return calendarLink
        },
        isHidden () {
            // let self = this
            console.log('isHidden () = ', this.user && this.user.corporation && this.user.corporation.corporationId === 200)
            return this.user && this.user.corporation && this.user.corporation.corporationId === 200
        }
    },
    computed: {
        ...mapGetters([
            'error', 'user', 'getDefaultPlan', 'getAuthUserVideos', 'getUserPlaylists', 'getTrialDays', 'getCorpPrivateEvents', 'getCorpAllEvents', 'getCorpPublicEvents', 'getCorpMainEvent', 'getAllExperts', 'getCorpArchiveEvents', 'getCorpPlaylists', 'getCorporationPinnedMsgs', 'getCropUserSharedVideos', 'getCorporatePayload', 'getEventSwitchTime', 'getCorpPrivateVideos', 'getTaggedEmailList', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getParentCorporation', 'getSwitchCorporateClient', 'getAllSiteContents'
        ])
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .mainbanner img {
        width: 100%;
        max-height: 60vh;
        object-fit: cover;
        object-position: center center;
    }

    .profileimageanddata {
        clear: both;
        max-width: 1170px;
        margin: auto;
    }

    .profileimage {
        float: left;
        width: 170px;
        height: 170px;
        border: 10px solid #fff;
        transform: translateY(-50%);
        box-shadow: 0px 0px 11px rgba(0,0,0,0.25);
    }

    .profileimage img {
        width: 150px;
        height: 150px;
        object-fit: cover;
        object-position:center center;
    }

    .textmatterholder {
        float: left;
        width: calc(100% - 170px);
        text-align: left;
        padding-left: 30px;
        padding-top: 20px;
    }
    .tabs ul {
        margin: 0 0;
        padding: 0;
        list-style: none;
        display:flex;
    }

    .tabs ul li {
        flex:1;
        text-align: center;
        float: left;
        padding: 20px;
        font-size: 21px;
        font-weight: 900;
        border-bottom:1px solid #333;
    }

    .tabs li.current{
        border-bottom:1px solid #f0617d;
    }

    li.current a {
        color: #f0617d;
    }

    li a {
        color: #333;
    }

    .tabs:after {
        content: "";
        display: table;
        clear: both;
        width: 100%;
    }
    .introparacard {
        padding-top: 30px;
        text-align: left;
    }

    .introparacard img {
        max-width: 100%;
    }

    .introparacard blockquote {
        text-align: center;
        border: 0 none transparent;
        padding: 0;
        margin: 20px 0 0;
        font-weight: 700;
        font-style: italic;
    }
    hr.redhr {
        border-color: #f0617d;
        max-width: 575px;
    }
    @media(max-width:767px){
        li a {
            font-size: 14px;
        }

        .textmatterholder {
            width: 100%;
            padding: 0 20px;
        }

        .profileimage {
            float: none;
            margin: auto;
            transform: translateY(-20px);
        }
    }
    .imgresponsive img {
        width: 100%;
        height: auto;
    }

    .large-text {
        font-size: 16px;
    }



    /* css for the video popup*/

    button#videoplayer_videoredirect {
        border-radius: 5px;
        font-weight: 700;
    }

    button#videoplayer_videostay {
        background: white;
        color: #44bda8;
        border: 1px solid #44bda8;
        white-space: normal;
        line-height: 1;
        padding: 6px;
        border-radius: 5px;
    }
    .watchVideoModal .modal-dialog .modal-body p {
        padding: 16px 60px 19px 60px;
    }
    .watchVideoModal.modal.zoom.in {
        z-index: 500000;
    }
    .sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader {
        background: #f0617d;
        color: #fff;
        font-size: 25px;
        text-align: left;
        padding: 15px 25px;
        font-weight: 700;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body p{
        padding: 0;
        margin: 0 0 20px;
    }
    .row.sharefb {
        background: #eee;
        margin-left: 0;
        margin-right: 0;
    }

    .row.sharefb > div {
        padding: 5px;
        text-align: left;
    }

    .row.sharefb .col-sm-5 img {
        max-width: 100%;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
        font-size: 14px;
        font-weight: 300;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6 {
        text-transform: uppercase;
        font-size: 12px;
        margin: 10px 0 5px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4 {
        margin: 0 0 5px;
        font-weight:700;
    }
    .row.buttonsinpopup {
        padding-top: 20px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
        background: #fff;
        color: #333;
        border: 1px solid #cacaca;
        width: 100%;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body {
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink {
        background: #f0617d;
        width: 100%;
        margin: 0;
        border: 1px solid #f0617d;
    }
    .usernamenimg.text-left table {
        max-width: 100%;
        margin: 0 0 20px;
        width: 190px;
    }
    a.popupsharingoptionlink {
        display: block;
        color: #fff;
        text-decoration: none;
        max-width: 150px;
        font-size: 18px;
        font-weight: 700;
        padding-top: 15px;
        text-align: center;
    }

    a.popupsharingoptionlink i:before {
        color: #fff;
    }

    a.popupsharingoptionlink i.fa.fa-share-square-o {
        margin: 0;
        font-size: 20px;
        /* display: block; */
    }
    .strongselec{
        font-weight:700;
    }
    @media(max-width:475px){
        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
            padding-left: 0;
            padding-right: 0;
        }
    }

    .showmobile{display:none;}
    @media(max-width:767px){
        .usernamenimg.text-left {
            display: none;
        }
        .showmobile{
            display: block;
        }
        .alert.alert-default {
            background: #eee;
        }

        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
            display: none;
        }
        .sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {
            top: 1px;
            right: -13px;
        }
        .row.sharefb {
            display: flex;
            align-items: center;
        }
        .pinksidebarmin{
            padding:0 !important;
            display: flex;
            flex-direction: column;
            flex-basis: auto;
            display: flex ;
            align-items: stretch ;
            justify-content: center;
        }

        .pinksidebarmin > * {
            padding: 6px 0 !important;
            margin: 0 !important;
            flex: 100;
            text-align:center;
        }
    }
    /* css for the video popup ends*/
    @media(min-width:768px) {
        .sliderimage {
            width: 100%;
            /* height: 200px;*/
            object-fit: cover;
            object-position: center;
        }
    }

    .row.video-row.plistisrow img {
        max-width: 80%;
    }

    .row.video-row.plistisrow .col-sm-6 {
        text-align: left;
    }

    .pinksidebarmin {
        float: right;
        width: 20%;
        background: #f0617d;
        text-align: center;
        padding: 20px;
    }

    .pinkbg {background: #f0617d;}

    .pinksidebarmin > * {
        font-size: 25px;
        color: #fff;
        cursor: pointer;
        margin:20px 0;
    }
    @media(min-width:768px){
        .row.video-row.plistisrow .pinkbg img {
            height: 205px;
            object-fit: cover;
        }
        .pinksidebarmin {
            display: flex;
            flex-direction: column;
            height: 205px;
            align-items: center;
            justify-content: space-around;
        }

        .pinksidebarmin > * {
            font-size: 25px;
            color: #fff;
            cursor: pointer;
            padding:0;
            margin:0;
        }

    }
    .col-sm-6.pltext {
        cursor: pointer;
        font-size: 16px;
    }


    .pltext h3 {
        text-decoration: underline;
    }

    .clearfix {
        clear: both;
    }

    .incaseumi {
        font-size: 18px;
    }

    .incaseumi img {
        width: 100%;
    }
    .borderedbox {
        border: 1px solid #ddd;
        padding: 15px;
        margin: 10px 0;
        font-size: 16px;
    }

    .pinnedmsgs {
        text-align: left;
    }

    .pinnedmsgs h3 {
        color: #f0617d;
    }
    .row.video-row.plistisrow .videoholdersuggestions img {
        width: 100%;
        max-width: none;
        cursor: pointer;
    }

    .videoholdersuggestions{
        margin:0 0 30px;
    }

    .videoholdersuggestions h3 {
        text-align: center;
        font-weight: 900;
        cursor: pointer;
    }

    .videoholdersuggestions p {
        font-size: 18px;
    }
    .row.video-row.plistisrow.lowerlist .col-sm-6:nth-of-type(odd) {
        clear: left;
    }

    .smallimgholder {text-align: center;padding: 10px;box-shadow: 0 0 5px rgba(0,0,0,0.5);}

    .smallimgholder img {
        height: auto;
        width: 100%;
    }
    @media(max-width:991px){
        .hidemobile {
            display: none;
        }

        .smallimgholder {
            max-width: 300px;
            margin: 0 auto;
        }
    }
    @media(max-width:991px){
        .tabs ul {
            display: flex;
            align-items: stretch;
            justify-items: stretch;
            justify-content: space-between;
        }
        .tabs ul li{
            width: auto;
            padding: 20px 0;
            flex: 1;
        }
        img.sliderimage {
            max-width: 100%;
        }
    }
    .row.yourFaves p.text-wrap-title.cursor {
        font-size: 16px;
        font-weight: 500;
        color: #000;
        text-align: left;
        line-height: 1.5;
    }
    .row.yourFaves {
        padding-top: 20px;
    }
    @media(min-width:992px) and (max-width:1200px){
        .tabs ul li {
            padding-right: 5px !important;
            padding-left: 5px !important;
        }
    }
    .m-auto {
        margin: auto;
        float: none;
    }
    .fourinarow .radio {
        flex: 1;
        max-width: 25%;
    }

    .fourinarow {
        display: flex;
    }

    .fourinarow .radio img {
        width: 100%;
        margin: 0 0 10px;
    }

    .fourinarow .radio.radio > label > input[type="radio"] {
    / display: block; /
    z-index: 100 !important;
        opacity: 1;
        margin: 0 0 0;
        padding: 0;
        z-index: 1;
        position: relative;
    }
    @media(max-width:767px){
        .fourinarow .radio {
            max-width: 50%;
        }
    }
    .fourinarow .radio .active span.heading {
        font-weight: 700;
    }

    .fourinarow .radio .active img.thumbnail {
        border: 1px solid #f0617d;
    }
    .fourinarow {
        align-items:baseline;
    }
    @media(max-width:767px){
        .fourinarow .radio {max-width: 50% !important;min-width: 50%;}
    }
    .fourinarow {display: flex;flex-wrap: wrap;}
    .fourinarow .radio > label {
        padding: 10px;
        width: 100%;
    }

    .fourinarow .radio > label img.thumbnail.embed-responsive-item {
        object-fit: cover;
        object-position: center;
    }
    .smallimgholder button.btn.formButton.btn-block {
        padding: 8px;
        font-size: 12px;
        white-space: unset;
    }
    button.share-event {
        color: rgb(240, 97, 125) !important;
        border: 1px solid rgb(240, 97, 125) !important;
        background-image: none !important;
        font-weight: 600;
        line-height: 100%;
        background: #fff !important;
        font-size: 15px !important;
        text-decoration: none;
        border-radius: 3px !important;
        cursor: pointer;
        -webkit-font-smoothing: antialiased!important;
        outline-color: rgba(0,78,255,0.5) !important;
        text-shadow: 1px 1px 1px rgb(0 0 0 / 0%);
        display: inline-block;
        position: relative;
        /*z-index: 99998;*/
        font-family: "Open Sans",Roboto,"Helvetica Neue",Helvetica,Optima,Segoe,"Segoe UI",Candara,Calibri,Arial,sans-serif !important;
        padding: 12px 12px 12px 12px !important;
        margin-left: 10px !important;
        width: 173px !important;
        display: inline-block;
        float: left !important;
        box-shadow: 0 0 0 0.5px rgba(50,50,93,.17), 0 2px 5px 0 rgba(50,50,93,.1), 0 1px 1.5px 0 rgba(0,0,0,.07), 0 1px 2px 0 rgba(0,0,0,.08), 0 0 0 0 transparent!important;
    }
    .addeventatc.pinkoutlinebtn {
        float: left;
    }
    .slick-slide .addeventatc.pinkoutlinebtn {
        padding: 13px 12px 12px 37px !important;
    }

    .slick-slide button.share-event {
        width: auto !important;
        margin: 0 10px;
    }
    @media(max-width:991px){
        .addeventatc.pinkoutlinebtn{
            margin-left:0 !important;
            margin-right:10px;
            margin-bottom:10px;
        }
        button.share-event{
            margin-left:0 !important;
        }
    }
    @media(max-width:767px){
        .addeventatc.pinkoutlinebtn{margin-left:10px !important;}
        button.share-event{
            margin-left:9px !important;
        }
    }
    .imgresponsive.large-text.text-left:after {
        content: "";
        display: block;
        clear: both;
    }
    .row.video-row.plistisrow.flexwrap{
        display: flex;
        flex-wrap: wrap;
    }
    .favnumbers {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: distribute;
        justify-content: space-around;
        position: absolute;
        right: 0px;
        top: 0;
        bottom: 0;
        padding: 10px;
        color: #fff;
        width: 74px;
        cursor: pointer;
    }

    .viderowraper-shared {
        position: relative;
    }

    .favnumbers div span{
        font-size: 170%;
        font-weight: 700;
        line-height: 1;
    }
    .favnumbers div span + small {
        display: block;
        line-height: 1;
    }

    span {}

    .favnumbers div {
        text-align: center;
    }

    .favnumbers i.fa {
        font-size: 200%;
    }
    @media(min-width:768px){
        .favnumbers i.fa {
            display: none;
        }

        .favnumbers:hover i.fa {
            display: block;
        }
    }
    .show-share-options {
        position: relative;
    }
    .show-share-options img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        object-position: center;
    }

    .show-share-options .favnumbers-a {
        position: absolute;
        background: #f0617d;
        top: 0;
        right: 0;
        width: 50px;
        bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 30px;
        font-weight: bold;
        color: #fff;
    }

    .show-share-options .favnumbers-a small {
        font-size: 11px;
        display: block;
        line-height: 1;
    }

    .show-share-options .favnumbers-a > div {
        line-height: 1;
    }

    @media(min-width:768px){
        .show-share-options .favnumbers{
            display:none;
        }
        .show-share-options:hover .favnumbers{
            display:flex;
        }
    }
    .show-share-options .favnumbers-a i:before {
        color: #fff !important;
    }
</style>




// WEBPACK FOOTER //
// CorporateCommunity.vue?6d49bd6a